// Capture user's page lang to hidden field

import pageLang from '../../util/pageLang.js'  
import GravityForms from './component.js'

class webLang extends GravityForms {
  constructor() {
    super()
    let form = this.form
    if (form) {
      let lang = pageLang
      let field = form.querySelector('[id="Web_Language__c"]')
      if (typeof lang === 'string' && field) {
        field.value = lang
      }
    }
  }
}

new webLang()


// WEBPACK FOOTER //
// ./scripts/routes/gravity-forms/webLang.js